module.exports = __webpack_public_path__ + "img/Wp_2018.5516ecf8.png";